<i class="fa fa-warning"></i> <ng-container>{{ message }}</ng-container>
